(() => {
  const body = document.body;
  if (!body || !body.classList.contains('cb-pasko')) return;

  const endDate = body.dataset.cbPaskoEnd;
  if (endDate) {
    const end = new Date(`${endDate}T23:59:59+08:00`);
    if (!Number.isNaN(end.getTime()) && Date.now() > end.getTime()) {
      body.classList.remove('cb-pasko', 'cb-pasko--glow', 'cb-pasko--fiesta');
      document.querySelectorAll('[data-cb-countdown], .cb-pasko-ribbon, .cb-christmas-garland').forEach((el) => el.remove());
      return;
    }
  }

  document.documentElement.classList.add('cb-pasko-ready');

  /* ---------- Noche Buena countdown, always in Philippine time ---------- */
  const tag = document.querySelector('[data-cb-countdown]');
  if (tag) {
    const DAY = 86400000;
    const manila = new Date(Date.now() + 8 * 3600000);
    const y = manila.getUTCFullYear();
    const m = manila.getUTCMonth();
    const d = manila.getUTCDate();
    const today = Date.UTC(y, m, d);
    let num = null;
    let label = '';
    if (m === 11 && d === 24) label = 'Noche Buena is tonight';
    else if (m === 11 && d === 25) label = 'Maligayang Pasko!';
    else if (m === 11 && d > 25) { num = Math.round((Date.UTC(y + 1, 0, 1) - today) / DAY); label = 'till Bagong Taon'; }
    else if (m === 0 && d === 1) label = 'Manigong Bagong Taon!';
    else if (m === 0) label = '';
    else { num = Math.round((Date.UTC(y, 11, 24) - today) / DAY); label = 'till Noche Buena'; }

    if (!label) {
      tag.remove();
    } else {
      const numEl = tag.querySelector('[data-cb-count-num]');
      const labelEl = tag.querySelector('[data-cb-count-label]');
      if (num !== null) {
        numEl.textContent = String(num);
        numEl.hidden = false;
        labelEl.textContent = `${num === 1 ? 'sleep' : 'sleeps'} ${label}`;
        tag.setAttribute('aria-label', `${num} ${num === 1 ? 'sleep' : 'sleeps'} ${label}`);
      } else {
        numEl.hidden = true;
        labelEl.textContent = label;
        tag.classList.add('cb-gift-tag--greeting');
      }
    }
  }

  /* ---------- 3D parol sky, loaded only when it can be enjoyed ---------- */
  const src = body.dataset.cbSkySrc;
  if (!src || !document.querySelector('[data-cb-sky]')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const conn = navigator.connection || {};
  const slowNet = conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
  const tinyDevice = navigator.deviceMemory && navigator.deviceMemory < 2;
  // Three.js needs WebGL2 (iOS 15+, all current Android and desktop browsers).
  // Older devices keep the flat parols and never download the 3D file.
  const noWebGL2 = !('WebGL2RenderingContext' in window);
  if (reduceMotion || slowNet || tinyDevice || noWebGL2) return;

  const load = () => {
    if (!body.classList.contains('cb-pasko')) return;
    import(src).catch(() => {});
  };
  const whenIdle = () => {
    if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 3000 });
    else setTimeout(load, 1200);
  };

  // Wait for the page (and its hero photo) to finish first, then for an
  // idle moment, so the lanterns never compete with what shoppers came for.
  const begin = () => {
    if (document.readyState === 'complete') whenIdle();
    else window.addEventListener('load', whenIdle, { once: true });
  };

  // A prerendered page waits until the shopper actually opens it.
  if (document.prerendering) {
    document.addEventListener('prerenderingchange', begin, { once: true });
  } else {
    begin();
  }
})();
